module.exports = __webpack_public_path__ + "static/media/nh-icon-it-con.ed09f330.png";